import { useEffect } from 'react';

import { deleteDrawing, drawCircleLine } from '../drawing/drawing.utils';
import { DMSToDecimal } from '../map-controls.utils';
import MapLayer from '../map-layer-manager/map-layer.enum';

const numericRegex = /^\d+(\.\d+)?$/;

/**
 * Draws or removes a circle outline on the given map layer whenever the centre
 * point or radius changes.
 *
 * - If the resolved coordinates are (0, 0) the drawing is removed, treating
 *   that as an unset/invalid position.
 * - The hook is purely a map-drawing side-effect; it has no knowledge of the
 *   data source or the form that produced the values.
 *
 * @param layer       - The map layer to draw the circle on.
 * @param centrePoint - DMS strings for the centre of the circle, or undefined.
 * @param radius      - Radius in nautical miles.
 */
export default function useMapLayerCircle(
  layer: MapLayer,
  centrePoint: { latitude: string; longitude: string } | undefined,
  radius: number
) {
  useEffect(() => {
    if (!centrePoint || !numericRegex.test(radius as any)) return;

    const coords = [
      DMSToDecimal(centrePoint.longitude) || 0,
      DMSToDecimal(centrePoint.latitude) || 0,
    ];

    if (coords[0] === 0 && coords[1] === 0) {
      deleteDrawing(layer);
    } else {
      drawCircleLine(layer, coords, radius, {
        'line-color': '#dbdbd9',
        'line-opacity': 1,
      });
    }
  }, [layer, centrePoint, radius]);
}
